import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { shopCartModule } from "./shopcart.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loadingCount: 0,
    loadingFinish: false,
    shopCartMessageShowCount: 0,
    mainDialog: {
      status: false,
      content: "",
    },
    // api資料
    commonColumnData: null, //通用欄位資料
    carouselData: null, //首頁輪播資料
    pageMetaData: null, //頁面meta資料
    // 經銷相關資料
    dealerData: null,
    //最新消息資料
    newsData: null,
    newsCategoryData: null,
    //影音專區資料
    videoData: null,
    videoCategoryData: null,
    //商品目錄資料
    menuCategoryData: null,
    categoryData: null, //商品分類資料
    eventData: null, //獨立銷售頁資料
    allProductData: null, //所有商品資料，包含已刪除以及停用的商品
    productData: null, //商品資料
    //付款相關資料
    zipCodeData: null,
    paymentData: null, //付款方式資料
    shipwayData: null, //物流方式資料
    brandData: null, //品牌資料
  },
  getters,
  mutations,
  actions,
  modules: {
    shopCartModule: shopCartModule,
  },
});

export default store;
